    
//     import React,{useState} from "react";
// import Button from "../../iconosv0/src/components/Button/Button";
// import Message from "../../iconosv0/src/components/Message/Message";
// import PrimaryMenu from "../../iconosv0/src/components/PrimaryMenu/PrimaryMenu";
// import SizeDefaultTypeArrowRight from "../../iconosv0/src/icons/SizeDefaultTypeArrowRight/SizeDefaultTypeArrowRight";

// import ActionSectionSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/ActionSectionSubsection/ActionSectionSubsection";
// import BannerSigupSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/BannerSigupSubsection/BannerSigupSubsection";
// import CardsOptionsSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/CardsOptionsSubsection/CardsOptionsSubsection";
// import CarouselCardsSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/CarouselCardsSubsection/CarouselCardsSubsection";
// import FootlerSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/FootlerSubsection/FootlerSubsection";
// import ReviewsSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/ReviewsSubsection/ReviewsSubsection";
// import TabletExperienceSubsection from "../../iconosv0/src/screens/ElementHomePage/sections/TabletExperienceSubsection/TabletExperienceSubsection";
// import '../../iconosv0/src/screens/ElementHomePage/style.scss';
//     {/* ===== HERO ===== */}
//      const wave = require("../../iconosv0/static/img/wave.svg").default;
//      const waver = require("../../iconosv0/static/img/waver-2.svg").default;
     
//      const Headerv2 = ({setOpen,open}) => {

        
//        return (
//         //  <main className="main" id="main" >
// <header
//   className="hero"
//   aria-label="Hero"
//   //style={{ "--hero-bg": `url(${wave})`,margin :0 }}
//     style={{margin :0 }}
// >

//     {/* PrimaryMenu, title, subtitle, <Message />, buttons, carousel… */}
 

//         <div className="container hero__inner" style={{minHeight:`${open?'50vh':'0'}`}}>
//           {/* Top navigation in normal flow */}
//           {/* <div className="hero__menu"> */}
//             <PrimaryMenu
//               className="primary-menu"
//               divClassName="is-primary"
//               divClassName1="is-light"
//               divClassNameOverride="is-light"
//               loginAndRegisterClassName="is-auth"
//               menuClassName="is-wide"
//               setOpen={setOpen}
//               open={open}
//             />
//           {/* </div> */}

       
        
//         </div>

//   {/* <span className="hero__glow" aria-hidden="true" /> */}
// </header>   
// //  </main>
//        );
//      }

//      export default Headerv2;




// Headerv2.jsx
import React from "react";
import PrimaryMenu from "../../iconosv0/src/components/PrimaryMenu/PrimaryMenu";

const Headerv2 = ({ open, setOpen }) => {
  return (
    <>
      {/* header lives at the top level */}
      <PrimaryMenu
        className="primary-menu"
        divClassName="is-primary"
        divClassName1="is-light"
        divClassNameOverride="is-light"
        loginAndRegisterClassName="is-auth"
        menuClassName="is-wide"
        setOpen={setOpen}
        open={open}
      />

      {/* hero becomes just the hero, not the header’s parent */}
      <header className="hero" aria-label="Hero" style={{ margin: 0 }}>
        <div className="container hero__inner" style={{ minHeight: open ? "50vh" : "0" }}>
          {/* …your hero content (no PrimaryMenu here)… */}
        </div>
      </header>
    </>
  );
};

export default Headerv2;
